module.exports = __webpack_public_path__ + "static/media/claro_thumb.45ae53c5.webp";